import { render } from "./MantenedorContratos.vue?vue&type=template&id=402a8f2a&scoped=true"
import script from "./MantenedorContratos.vue?vue&type=script&lang=js"
export * from "./MantenedorContratos.vue?vue&type=script&lang=js"

import "./MantenedorContratos.vue?vue&type=style&index=0&id=402a8f2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402a8f2a"]])

export default __exports__